// Auto-generated actions registry file - do not edit manually
// Language: javascript

const actionsRegistry = {
  actionCreate: "mrn:meesho:supply_admin:action/create",
  actionDelete: "mrn:meesho:supply_admin:action/delete",
  actionDownload: "mrn:meesho:supply_admin:action/download",
  actionRead: "mrn:meesho:supply_admin:action/read",
  actionUpdate: "mrn:meesho:supply_admin:action/update"
};

module.exports = { actionsRegistry };
